import React, { FC } from 'react';
import CircleCancel from 'dibs-icons/exports/CircleCancel';
import CircleCheck from 'dibs-icons/exports/CircleCheck';

import styles from './ProgressTask.scss';

import { TaskState } from '../helpers/progressTasks';

export const ProgressTask: FC<TaskState> = ({ completed, label }) => {
    const Icon = completed ? CircleCheck : CircleCancel;
    const iconClass = completed ? styles.checkCompleteWrapper : styles.checkIncompleteWrapper;
    const labelClass = completed ? styles.label : styles.labelIncomplete;
    return (
        <div className={styles.wrapper}>
            <Icon className={iconClass} />
            <div className={labelClass}>{label}</div>
        </div>
    );
};
